<template>
  <div class="pdf">
    <pdf
      v-for="i in numPages"
      :key="i"
      :src="pdfUrl"
      :page="i">
    </pdf>
  </div>
</template>
<script>
import pdf from 'vue-pdf'
export default {
  name: 'Pdf',
  components: {
    pdf
  },
  data() {
    return {
      baseUrl: '',
      pdfUrl: '',
      numPages: undefined,
      activeIndex: 0,
    }
  },
  mounted: function() {
    let url = this.$route.query.url
    this.baseUrl = window.downloadurl
    this.pdfUrl = this.baseUrl + url
    this.pdfTask(this.pdfUrl)
  },
  methods: {
    pdfTask(pdfUrl) {
      var loadingTask = pdf.createLoadingTask(pdfUrl)
      loadingTask.promise.then(pdf => {
        this.numPages = pdf.numPages
      })
    }
  }
}
</script>
<style scoped>
  .pdf{
    width: 60%;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%);
  }
</style>
